import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children, allowedRoles }) => {
  const { isAuthenticated, isAdmin, hasRole, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has access: either admin or one of the allowed roles
  const hasAccess = isAdmin || (allowedRoles && allowedRoles.some(role => hasRole(role)));

  if (!hasAccess) {
    return (
      <div style={{
        padding: '2rem',
        textAlign: 'center',
        backgroundColor: '#f8f9fa',
        border: '1px solid #dee2e6',
        borderRadius: '8px',
        margin: '2rem auto',
        maxWidth: '600px'
      }}>
        <h2 style={{ color: '#dc3545', marginBottom: '1rem' }}>Access Denied</h2>
        <p style={{ color: '#6c757d', fontSize: '1.1rem' }}>
          You do not have permission to access this page.
        </p>
        <p style={{ color: '#6c757d', marginTop: '1rem' }}>
          Please contact your administrator if you believe you should have access.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}; 